// extracted by mini-css-extract-plugin
export var aboveInput = "_ke-0";
export var actionButton = "_ke-5";
export var actionButtonContainer = "_ke-1";
export var actionIcon = "_ke-6";
export var aiInfoContainer = "_ke-2";
export var attachmentWrapper = "_ke-7";
export var bold = "_ke-3";
export var checkIcon = "_ke-8";
export var clickingRecipientBar = "_ke-11";
export var commentThreadSwitch = "_ke-a";
export var draftImage = "_ke-b";
export var draftImageContainer = "_ke-c";
export var draftImages = "_ke-e";
export var editButton = "_ke-g";
export var editor = "_ke-f";
export var editorContainer = "_ke-y";
export var editorErrorTooltipWrapper = "_ke-9";
export var headerDivider = "_ke-h";
export var icon = "_ke-i";
export var info = "_ke-j";
export var internal = "_ke-n";
export var internalDivider = "_ke-k";
export var internalMessage = "_ke-l";
export var messageInputCard = "_ke-m";
export var messageInputForm = "_ke-o";
export var messageInputFormInternal = "_ke-p";
export var options = "_ke-q";
export var publicMessageCustomer = "_ke-s";
export var publicMessageMerchant = "_ke-r";
export var removeImageButton = "_ke-d";
export var replyButtons = "_ke-t";
export var showSignatureButton = "_ke-u";
export var spinner = "_ke-v";
export var verticalButtonDivider = "_ke-4";
export var visibilitySelector = "_ke-w";
export var warning = "_ke-x";
export var wrappingText = "_ke-z";
export var writingInternalNoteTopBorder = "_ke-10";